module.exports = __webpack_public_path__ + "static/media/btbms_mobile_hero_en.28dae544.jpg";